import jiraProductDiscoveryCloud from 'data/products/jira.product.discovery';
import Category from 'model/Category';

export default new Category('discovery', jiraProductDiscoveryCloud);
